import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Container, Row, Col, Nav, Navbar, NavDropdown, Image } from 'react-bootstrap';
import * as Cookies from "es-cookie";
import ChangePassword from '../components/navbars/ChangePassword';
import CommonHeader from '../components/navbars/CommonHeader';
import BrandLogo from '../components/navbars/BrandLogo';

class CustomsubmitBack extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modalShow: false
        }
    }
    logout = () => {
        if (Cookies.get("studenttoken") !== undefined) {
            Cookies.remove("studenttoken");
            Cookies.remove("studentusername");
            Cookies.remove("studentrefreshtoken");
            Cookies.remove("studentemail");
            Cookies.remove("registermob");
            Cookies.remove("classid");
            Cookies.remove("examid");
            Cookies.remove("mobileverified");
            Cookies.remove("targetyear");
            Cookies.remove("role");
            if (Cookies.get("institution_id") == 119) {
                window.location.href = "https://vignan.rizee.in/login";
            } else {
                this.props.history.push("/student/login");
            }
        }
    };
    render() {
        if (Cookies.get("studenttoken") == undefined)
            this.props.history.push("/student/login");
        return (
            <div className="PracticeInstructions">
                <CommonHeader color="auto" tone="light" left={<BrandLogo width="159.501" fill="#ffffff" />} />
                <div className="bg-success py-3">
                    <Container fluid className="d-flex justify-content-between align-items-center">
                        <Link to={{
                            pathname: "/student/exams/custom-exam",

                        }} className="my-0 font-weight-normal text-light"><i className="fal fa-arrow-left" /> Back</Link>
                        <div className="my-2 my-md-0 text-center">
                            <h6 className="title mb-0 mr-4 text-white">You have completed practice test successfully</h6>
                        </div>
                        <div>&nbsp;</div>
                    </Container>
                    <ChangePassword
                        show={this.state.modalShow}
                        onHide={() => this.setState({ modalShow: false })}
                    />
                </div>

                <div className="bg-white py-3 border-top shadow-sm">
                    <Container>
                        <Row>
                            <Col xl={12} lg={12} md={12} className="text-right">
                                <Link
                                    to={{
                                        pathname: "/student/exams/custom-exam",

                                    }}

                                    className="btn btn-outline-primary px-5">Back</Link>
                                {/* <Button variant="outline-danger" className="px-4" onClick={this.props.pcancelFunction} style={{ borderRadius: 25 }}><i className="fal fa-times mr-2" /> Close</Button> */}
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        )
    }
}

export default CustomsubmitBack
